/* src/app/admin/client/client.component.scss */
/*# sourceMappingURL=client.component-O7H35QQJ.css.map */
